import React from 'react';
import {
  Datagrid,
  NumberField,
  ReferenceManyField,
  FunctionField,
  useRefresh,
  useDataProvider,
} from 'react-admin';
import { Pagination } from 'Components';
import CreateButton from '../../EventEvidence/QuickCreate';
import { tabbedLists } from '../../../styles';
import { isSuperAdmin, isAdmin } from 'utils';
import { Button } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPrint } from '@fortawesome/pro-regular-svg-icons';
const EvidenceTab = (props) => {
  const classes = tabbedLists();
  const refresh = useRefresh();
  const { permissions, record } = props;

  const dataProvider = useDataProvider();

  const handlePrintAllEvidence = () => {
    dataProvider
      .getList('eventEvidence', {
        filter: { eventId: props.record.id },
        pagination: { page: 1, perPage: 1000 },
        sort: { field: 'orderIndex', order: 'ASC' },
      })
      .then(({ data }) => {
        const pdfUrls = data.map((record) => record.pdf?.url).filter((url) => url !== undefined);
        pdfUrls.forEach((url) => window.open(url));
      })
      .catch((error) => {
        console.error(error);
      });
  }

  return (
    <>
      <div className={classes.actions}>
        {(isSuperAdmin(permissions) || isAdmin(permissions)) && (
          <CreateButton record={record} onChange={() => refresh()} />
        )}
        <Button style={{
          marginTop: '35px',
          fontSize: '13px',
          color: '#243f56',
        }}
          onClick={handlePrintAllEvidence}>
          <FontAwesomeIcon icon={faPrint} /> &nbsp; Open all evidence
        </Button>
      </div >
      <ReferenceManyField
        reference="eventEvidence"
        target="eventId"
        source="id"
        sort={{ field: 'orderIndex', order: 'ASC' }}
        pagination={<Pagination />}
        perPage={50}
      >
        <Datagrid
          rowClick={(id, basePath, record) => {
            return {
              pathname: `/eventEvidence/${record.id}`,
              state: {
                eventId: props.record.id,
                hasEditor: record.content ? true : false,
                record
              }
            }
          }}
        >
          <FunctionField
            label="Evidence Name"
            render={(record) => {
              return record.name ? record.name : record.evidenceId.name
            }
            }
          />
          <NumberField
            label="Evidence folder"
            source="folderNumber"
            sortable={false}
          />
          <NumberField source="orderIndex" sortable={false} />
          <NumberField source="requiredActors" sortable={false} />
        </Datagrid>
      </ReferenceManyField>
    </>
  );
};

export default EvidenceTab;